module.exports = __webpack_public_path__ + "static/media/projectsBanner.5e9adf7a.png";